<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="searchbox">
				<div style="margin-right: 10px;margin-left: 10px;">
					<el-input style="width:160px;margin-right: 10px;" placeholder="请输入名称" v-model="params.keyword" @keyup.enter.native="clickSearch"
					clearable size="small"></el-input>
					<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
				</div>
				<div style="margin-right: 10px;">
					<el-select v-model="params.shopId" placeholder="请选择" clearable @change="clickSearch" size="small" style="width: 120px;">
						<el-option v-for="item in this.$store.state.userInfo.shops" :key="item.shop_id" :label="item.shop_name" :value="item.shop_id">
						</el-option>
					</el-select>
				</div>
				<div style="text-align: right;flex: 1;margin-right: 10px;">
					<!-- <el-button icon="el-icon-plus" type="primary" @click="addProductType('')">新建类型</el-button> -->
					<el-button   v-if="$buttonAuthority('chanpin-medical-add')" icon="el-icon-plus" type="warning" @click='addMedical()' size="small">新建药品</el-button>
				</div>
		</div>
		<div class="con">
			<div class="left">
				<el-button style="margin-left: 20px;" size="mini"  @click="addProductType('')">添加</el-button>
				<el-button size="mini" type="warning" @click="resetProductType">重置</el-button>
				<el-tree class="elTree" style="margin-top: 10px;" v-if="categoryData[0]" :data="categoryData[0].children" :highlight-current='isHighlight' node-key="id" default-expand-all :expand-on-click-node="false" :render-content="renderContent" @node-click ='handleNodeClick'>
				</el-tree>
			</div>
			<div class="table">
				<el-table :data="washData" style="width: 100%">
					<el-table-column prop="title" label="项目名称">
						<template slot-scope="scope">
							<div v-if="$public.isNull(scope.row.cover)">{{scope.row.title}} {{scope.row.buy_back == 0?'不复购':'复购'}}</div>
							<el-tooltip v-else placement="top" effect="light">
								<div slot="content">
									<img :src="scope.row.cover"  style="width:300px;"/>
								</div>
								<div>{{scope.row.title}} {{scope.row.buy_back == 0?'不复购':'复购'}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="适用宠物">
						<template slot-scope="scope">
							<span>{{scope.row.apply_type.title}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="品牌">
						<template slot-scope="scope">
							<span>{{scope.row.brand_name}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="分类">
						<template slot-scope="scope">
							<span>{{scope.row.category_info.name}}</span>
						</template>
					</el-table-column>
					<el-table-column  label="规格">
						<template slot-scope="scope">
							<div style="display: flex;">
								<div style="margin-right: 10px;">{{scope.row.old_packinfo_info.sku_value}}</div>
								<div v-if="scope.row.stop_sale_time != null">
									<el-tooltip class="item" effect="dark" :content="scope.row.stop_sale_time" placement="right" v-if="scope.row.status == 0">
										<span>暂停</span>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" :content="scope.row.stop_sale_time" placement="right" v-if="scope.row.status == -1">
										<span>作废</span>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" :content="scope.row.stop_sale_time" placement="right" v-if="scope.row.status == 1">
										<span>启用</span>
									</el-tooltip>
									<!-- <span v-if="item.status == 1">启用</span> -->
								</div>
								<div v-if="scope.row.stop_sale_time == null">
									<span v-if="scope.row.status == 1">启用</span>
									<span v-if="scope.row.status == 0">暂停</span>
									<span v-if="scope.row.status == -1">作废</span>
								</div>
							</div>
							
						</template>
					</el-table-column>
					<el-table-column  label="价格"  prop="pprice">
						<template slot-scope="scope">
							<span>标准价￥{{scope.row.pprice}}</span>
							<span v-if="scope.row.mprice">会员价￥{{scope.row.mprice}}</span>
							<span>
								<el-popover placement="right" width="400" trigger="hover">
									<el-table :data="scope.row.stock">
										<el-table-column   property="shopName" label="门店"></el-table-column>
										<el-table-column   property="stock" label="库存"></el-table-column>
									</el-table>
									<el-button  slot="reference" style="margin-left: 10px;" icon="el-icon-view" size="mini" type="text">
									</el-button>
								</el-popover>
							</span>
						
						</template>
						
					</el-table-column>
				
					<!-- <el-table-column  label="适用门店">
						<template slot-scope="scope">
							<div v-for="item in scope.row.shop_info" :key='item.shop_id'>{{item.shop_name}}</div>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="remark" label="备注">
					</el-table-column> -->
					<el-table-column  label="操作" width="180px">
						<template slot-scope="scope">
							<el-button type="text" size="small" @click='uploadImg(scope.row)'>上传图片</el-button>
							<el-button   v-if="$buttonAuthority('chanpin-medical-edit')" type="text" icon='el-icon-edit' size="small" @click='edit(scope.row.medical_id)'>编辑</el-button>
							<!-- <el-button type="text" icon='el-icon-view' size="small" @click='lookdetail(scope.row._id)'>查看</el-button> -->
							<el-button   v-if="$buttonAuthority('chanpin-medical-del')" type="text" icon='el-icon-delete' size="small" @click='deleted(scope.row.medical_id)'>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<page :total="total" :page="params.pageIndex" @change="changePage" style="padding: 10px 0;"></page>
			</div>
		</div>
		
		<el-dialog title="医疗类型设置" :visible.sync="dialogProductType" width="30%" :close-on-click-modal='false'>
			<el-form ref="editProductParams" label-width="80px">
				<el-form-item label="类型名称">
				<el-input v-model="editProductParams.typeName" size='mini' style="width: 200px;"></el-input>
				</el-form-item>
				<el-form-item>
				<el-button size="small" type="primary" @click="onSubmitProductType">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog v-if="dialogUploadImg_state" title="上传图片" :visible.sync="dialogUploadImg_state" width="60%" :close-on-click-modal='false' top="5vh">
			<el-form ref="editProductParams" label-width="80px">
				<el-form-item label="主图:">
					<uploadImg :fileLists="fileLists1" :num="1" @sendImg="sendImg1"></uploadImg>
				</el-form-item>
				<el-form-item label="详情:">
					<uploadImg :fileLists="fileLists3" :num="5"  @sendImg="sendImg3"></uploadImg>
				</el-form-item>
				<el-form-item style="text-align: center;">
					<el-button style="width:100px;" size="small" type="warning" @click="submit_dialogUploadImg">确定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

	</div>
</template>

<script>
	
	import page from "../../../components/page.vue"
	import {
		// VUE_APP_Url_baseData
		getProductMedicalList,  // api.post(`${baseURL2}api/product/medical/list`
		deleteProductMedical,  // api.delete(`${baseURL2}api/product/medical`
		getProductTypeList,  // api.get(`${baseURL2}api/dict/ProductType/tree`
		setProductType,  // api.post(`${baseURL2}api/dict/ProductType/update`
		deleteProductType,  // pi.delete(`${baseURL2}api/dict/ProductType`
		getProductTypeDl  // api.get(`${baseURL2}api/dict/ProductType/codemodel`
	} from '../../../api/productApi.js'
	import uploadImg from "../../../components/uploadImg.vue"
	export default {
		components: {
			page,uploadImg
		},
		data() {
			return {
				fixedHeight:'',
				dialogWashService: false,
				washData: [],
				isHighlight:true,
				params: {
					keyword: '',
					categoryId: '',
					shopId: this.$store.getters.curShopInfo.shop_id,
					pageIndex: 1,
					pageSize: 10,
				},
				total: 0,
				productTypeIds: [],
				categoryData: [],
				dialogProductType: false,
				editProductParams: {
					status: 1,
					category: '医疗',
					typeName: '',
					parentId:'',
				},
				
				storeIds: [],
				// 上传图片
				dialogUploadImg_state:false,
				uploadImgParams:{},
				fileLists1:[],
				fileLists3:[],
			}
		},

		methods: {
			// 上传图片
			uploadImg(row){
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_Url_8000+'/api/product/medical/images', {id:row.medical_id}).then(res => {
					loading.close()
					if (res.code == 0) {
						let d = res.data;
						this.uploadImgParams = d;
						
						this.fileLists1 = []
						if(!this.$public.isNull(d.cover)){
							this.fileLists1 = [{url:d.cover, name:d.cover.substr(d.cover.length-21)}];
						}
						this.fileLists3 = []
						if(!this.$public.isNull(d.detailImgList)){
							for(let i=0;i<d.detailImgList.length;i++){
								this.fileLists3.push({url:d.detailImgList[i], name:d.detailImgList[i].substr(d.detailImgList[i].length-21)})
							}
						}
						
						this.dialogUploadImg_state = true;
					}
				})
			},
			sendImg1(list){
				this.uploadImgParams.cover = list[0].url;
			},
			sendImg3(list){
				this.uploadImgParams.detailImgList = []
				for(let i=0;i<list.length;i++){
					this.uploadImgParams.detailImgList.push(list[i].url)
				}
			},
			submit_dialogUploadImg(){
				let params = this.uploadImgParams;
				console.log(params)
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_Url_8000+'/api/product/medical/update/images', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getProductMedicalList();
						this.dialogUploadImg_state = false;
					}
				})
			},
			getProductMedicalList() {
				getProductMedicalList(this.params).then(res => {
					if (res.code == 0) {
						console.log(res)
						this.washData = res.data.data;
						this.total = res.data.count;
					}
				})
			},
			clickSearch() {
				this.params.pageIndex = 1;
				this.getProductMedicalList();
			},
			changePage(val) {
				this.params.pageIndex = val;
				this.getProductMedicalList();
			},
			addMedical() {
				this.$router.push({
					path:'/medical/addmedical',
				})
			},
			getStoreInfo(shopinfo) {
				this.editParams.shop_info = shopinfo;
			},
			
			edit(id) {
				this.$router.push({
					path:'/medical/addmedical',
					query:{
						id,
					}
				})
			},
			deleted(id) {
				this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteProductMedical({
						id
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getProductMedicalList();
						}
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			lookdetail(id){
				console.log(id);
			},
			renderContent(h, { node, data}) {
				return (
				<span  class="custom-tree-node"  v-if="$buttonAuthority('chanpin-goods-sort')">
				<span>{node.label}</span>
				<span class='custom-tree-btn'>
				<el-button size="mini" type="text" icon = 'el-icon-plus' on-click={ () => this.addProductType(data) }></el-button>
				<el-button size="mini" type="text" icon = 'el-icon-edit' on-click={ () => this.editProductType(data) }></el-button>
				<el-button size="mini" type="text" icon = 'el-icon-delete' on-click={ () => this.remove(node, data) }></el-button>
				</span>
				</span>
				)   
			},
			addProductType(data) {
				if(data){
					this.editProductParams.parentId = data.id;
					this.editProductParams.typeName = '';
					this.editProductParams.typeId = '';
				}else{
					this.editProductParams.parentId =this.categoryData[0].id;
					this.editProductParams.typeName = '';
				}
				
				this.dialogProductType = true;
				
			},
			
			onSubmitProductType(){
				if(!this.editProductParams.typeName){
					this.$message({
						type: 'warning',
						message: '类型名称不能为空'
					});
				}else{
					setProductType(this.editProductParams).then(res=>{
						if(res.code==0){
							this.$message({
								type: 'success',
								message: '设置成功'
							});
							this.dialogProductType = false;
							this.getProductTypeList();
						}
					})
				}
				
			},
			remove(node, data) {
				this.$confirm('请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteProductType({
						id:data.id
					}).then(res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getProductTypeList();
						}
					})
				
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
				
			},
			getProductTypeList() {
				getProductTypeList({
					category: '医疗'
				}).then(res => {
					if (res.code == 0) {
						this.categoryData = res.data;
						
					}
				})
			},
			editProductType(data){
				console.log(data)
				this.dialogProductType = true;
				this.editProductParams.typeId = data.id;
				this.editProductParams.typeName = data.label;
				this.editProductParams.parentId = '';
				
			},
			handleNodeClick(data){
				
				this.params.categoryId = data.id;
				this.getProductMedicalList();
			},
			changeCategory(val) {
				if(val.length>0){ 
					getProductTypeDl({id:val[val.length-1]}).then(res=>{
						if(res.code==0){
							this.editParams.basic_info.category_info['name'] = res.data.name;
							this.editParams.basic_info.category_info['_id'] = res.data._id;
							this.editParams.basic_info.category_list = res.data.parent_all;
						}
					})			
				}
			},
			resetProductType(){
				this.isHighlight = false;
				this.params.categoryId = '';
				this.getProductTypeList();
			},
			
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 86;
			this.getProductMedicalList();
			this.getProductTypeList()
		}
	}
</script>

<style  lang="scss" scoped>
	.page {
		.searchbox {
			background-color: #fff;
			height: 72px;
			display: flex;
			align-items: center;
		}

		.con {
			display: flex;
			margin-top: 10px;

			.left {
				width: 180px;
				background-color: #fff;
				margin-right: 20px;
				padding: 10px;
				&::-webkit-scrollbar {
					width: 4px;
					// height: 4px;
				}
				.elTree{
					font-size: 12px;
					::v-deep .custom-tree-node{
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: space-between;
						font-size: 12px;
						padding-right: 8px;
					}
					::v-deep .custom-tree-btn{
						display: none;
					}
					::v-deep .custom-tree-node:hover .custom-tree-btn{
						display: block;
					}
				}
			}

			.table {
				flex: 1;
				background-color: #fff;
				padding: 0 20px;
			}
		}
	}
</style>
